import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "text-muted"
}
const _hoisted_2 = { class: "product-content" }
const _hoisted_3 = { class: "product-title" }
const _hoisted_4 = { class: "product-subtitle" }
const _hoisted_5 = {
  key: 0,
  class: "p-2"
}
const _hoisted_6 = {
  key: 1,
  class: "p-2"
}

import Api from '@/services/api';
import { Upload } from '@element-plus/icons-vue/dist/types';
import { ElMessage, ElRow } from 'element-plus';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'ProductsList',
  props: {
    items: {}
  },
  emits: ["clickOpen"],
  setup(__props: any, { emit: __emit }) {

const props = __props

    const emit = __emit
    const clickOpen = (id: number | string) => {
        emit('clickOpen', id)
    }

    const featured = async (row: any) => {
        row.loading = true
        const res = await Api.put(`admin/featured/product/${row.id}`, {})
        if (res.status != 200) {
            ElMessage.error({message: 'Ocorreu um erro ' + res.data.message ? res.data.message:''})
        } else {
            ElMessage.success({message: row.title + ' Actualizado com sucesso'})
            row.featured = !row.featured
        }
        row.loading = false
    }

return (_ctx: any,_cache: any) => {
  const _component_el_avatar = _resolveComponent("el-avatar")!
  const _component_View = _resolveComponent("View")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_card = _resolveComponent("el-card")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (__props.items.length === 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, " Nenhum produto "))
      : _createCommentVNode("", true),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.items, (item, index) => {
      return (_openBlock(), _createBlock(_component_el_card, {
        key: index,
        class: "product-item mb-1 p-2",
        "body-class": "no-padding",
        "body-style": {padding: '0px !important'},
        shadow: "hover"
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(ElRow), {
            align: "middle",
            items: "center",
            justify: "space-between"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", null, [
                _createVNode(_unref(ElRow), {
                  align: "middle",
                  items: "center"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_avatar, {
                      size: 48,
                      src: item.image ?? undefined,
                      class: "me-3"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(item.title.charAt(0)), 1)
                      ]),
                      _: 2
                    }, 1032, ["src"]),
                    _createElementVNode("div", _hoisted_2, [
                      _createElementVNode("div", _hoisted_3, _toDisplayString(item.title), 1),
                      _createElementVNode("div", _hoisted_4, _toDisplayString(item.subtitle), 1)
                    ])
                  ]),
                  _: 2
                }, 1024)
              ]),
              _createElementVNode("div", null, [
                _createVNode(_component_el_button, {
                  type: "primary",
                  circle: "",
                  class: "ml-auto",
                  onClick: ($event: any) => (clickOpen(item.id))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_icon, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_View)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["onClick"]),
                _createElementVNode("template", null, [
                  (!item.featured)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_5, [
                        _createVNode(_component_el_button, {
                          loading: item.loading,
                          onClick: () => featured(item),
                          type: "success",
                          title: "Destacar",
                          icon: "Upload"
                        }, null, 8, ["loading", "onClick"])
                      ]))
                    : (_openBlock(), _createElementBlock("span", _hoisted_6, [
                        _createVNode(_component_el_button, {
                          loading: item.loading,
                          onClick: () => featured(item),
                          type: "warning",
                          title: "Despromover",
                          icon: "Download"
                        }, null, 8, ["loading", "onClick"])
                      ]))
                ])
              ])
            ]),
            _: 2
          }, 1024)
        ]),
        _: 2
      }, 1024))
    }), 128))
  ], 64))
}
}

})